export default __webpack_public_path__ + "static/media/Wound-hoe of Picts Ruin.42d8fb5d.jpg";